<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="mt-4">
    <div class="grid md:grid-cols-2 gap-2 mt-2">
      <div class="flex flex-col col-span-2">
        <label class="soft-label top required">Tätigkeit</label>
        <soft-input formControlName="taskLabel" softFieldValidation></soft-input>
      </div>
      <div class="flex flex-col">
        <label class="soft-label top required">Startdatum</label>
        <soft-date-input formControlName="beginDay" softFieldValidation></soft-date-input>
      </div>
      <div class="flex flex-col">
        <label class="soft-label top required">Startzeit</label>
        <soft-time-input
          formControlName="beginTime"
          softFieldValidation
        ></soft-time-input>
      </div>
      <div class="flex flex-col">
        <label class="soft-label top required">Enddatum</label>
        <soft-date-input formControlName="endDay" softFieldValidation></soft-date-input>
      </div>
      <div class="flex flex-col">
        <label class="soft-label top required">Endzeit</label>
        <soft-time-input formControlName="endTime" softFieldValidation></soft-time-input>
      </div>
      <div class="flex flex-col col-span-2">
        <label class="soft-label top">Beschreibung</label>
        <soft-multiline-input
          [lines]="5"
          formControlName="comment"
          softFieldValidation
        ></soft-multiline-input>
      </div>
      <div class="flex flex-col">
        <label class="soft-label top required">Status</label>
        <soft-input formControlName="status" softFieldValidation></soft-input>
      </div>
      <div class="flex flex-col">
        <label class="soft-label top required">Typ</label>
        <soft-input formControlName="type" softFieldValidation></soft-input>
      </div>
    </div>
  </div>
</form>

<button type="button" class="soft-button accent h-14 w-full mt-4" (click)="onSubmit()">
  <div class="flex flex-row justify-center">
    <soft-icon name="fa-regular fa-floppy-disk" class="mr-2"></soft-icon>
    Erstellen
  </div>
</button>
